import React from 'react';

export default function CarousellSection() {
  return (
    <div className="flex flex-col gap-y-1 text-sm">
      <h4 className="font-semibold mb-0">Carousell</h4>
      <ul className="text-content-secondary">
        {[
          {
            title: 'Certified Cars',
            url: 'https://www.carousell.sg/s/20366/',
            external: true,
          },
          {
            title: 'Direct Owner Cars',
            url: 'https://www.carousell.sg/categories/cars-32/used-cars-singapore-1173/?addRecent=true&canChangeKeyword=true&includeSuggestions=true&is_direct_owner=true',
            external: true,
          },
          {
            title: 'Used Cars',
            url: 'https://www.carousell.sg/used-cars-singapore/h-1233/',
            external: true,
          },
          {
            title: 'Car Rental',
            url: 'https://www.carousell.sg/car-rental-singapore/h-1241/',
            external: true,
          },
          {
            title: 'Parallel Import Cars',
            url: 'https://www.carousell.sg/parallel-import-cars/h-2316/',
            external: true,
          },
          {
            title: 'Commercial Vehicles',
            url: 'https://www.carousell.sg/commercial-vehicles-singapore/h-2563/',
            external: true,
          },
          {
            title: 'Car Accessories',
            url: 'https://www.carousell.sg/car-accessories-servicing-workshops/h-136/',
            external: true,
          },
          {
            title: 'Motorcycles For Sale',
            url: 'https://www.carousell.sg/motorcycles/h-133/',
            external: true,
          },
        ].map((item) => (
          <li key={item.title}>
            <a
              className="text-content-secondary visited:text-content-secondary leading-relaxed"
              href={item.url}
              target={item.external ? '_blank' : '_self'}
              rel={item.external ? 'noreferrer' : ''}
            >
              {item.title}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
